  document.addEventListener("DOMContentLoaded", function() {
      // Define watcher count ranges for each time segment
      var timeRanges = {
          night: { min: 4, max: 10 }, // 12:00 AM to 5:00 AM
          morning: { min: 11, max: 24 }, // 5:01 AM to 10:00 AM
          noon: { min: 25, max: 35 }, // 10:01 AM to 5:00 PM
          afternoon: { min: 16, max: 23 } // 5:01 PM to 11:59 PM
      };

      function getTimeSegment() {
          var now = new Date();
          var hours = now.getHours();
          var minutes = now.getMinutes();

          if (hours >= 0 && (hours < 5 || (hours === 5 && minutes === 0))) {
              return "night";
          } else if (hours >= 5 && (hours < 10 || (hours === 10 && minutes === 0))) {
              return "morning";
          } else if (hours >= 10 && (hours < 17 || (hours === 17 && minutes === 0))) {
              return "noon";
          } else {
              return "afternoon";
          }
      }

      var productId = "{{ product.id }}"; // Unique ID for each product in Shopify
      var storageKey = "watchersCount_" + productId;

      // Function to get the current watcher count
      function getWatcherCount() {
          var timeSegment = getTimeSegment();
          var range = timeRanges[timeSegment];
          var previousValue = parseInt(localStorage.getItem(storageKey));

          if (isNaN(previousValue)) {
              // Initialize with a random number within the current range
              return Math.floor(Math.random() * (range.max - range.min + 1)) + range.min;
          } else {
              // Change the value by -2, -1, 0, +1, or +2 for subtle changes
              var changeOptions = [-2, -1, 0, 1, 2];
              var change = changeOptions[Math.floor(Math.random() * changeOptions.length)];
              var currentValue = previousValue + change;

              // Ensure the value stays within the current range
              if (currentValue < range.min) currentValue = range.min;
              if (currentValue > range.max) currentValue = range.max;

              return currentValue;
          }
      }

      // Function to update the watcher count
      function updateWatcherCount() {
          var currentValue = getWatcherCount();
          document.getElementById('watchers-count').textContent = currentValue;
          localStorage.setItem(storageKey, currentValue);
      }

      // Initial update
      updateWatcherCount();

      // Update every 5 seconds
      setInterval(updateWatcherCount, 5000);
  });